import dynamic from 'next/dynamic';
import type { Step } from '../flows';
export const anchor: Step[] = [{
  step: 'intro',
  screenViewEvent: {
    name: 'anchored_fix_scheduling_intro',
    content_id: 'anchored_fix_onboarding'
  },
  Component: dynamic(() => import('../../Intro/Intro').then(module => module.Intro), {
    ssr: false
  }),
  bgColor: 'mint',
  navBgColor: 'mint'
}, {
  step: 'fix-cart',
  screenViewEvent: {
    name: 'anchored_fix_scheduling',
    content_id: 'anchored_fix_onboarding'
  },
  gutter: 'narrow',
  Component: dynamic(() => import('../../FixCart/FixCart').then(module => module.FixCart), {
    ssr: false
  })
}, {
  step: 'schedule',
  screenViewEvent: {
    name: 'fix_frequency'
  },
  gutter: 'narrow',
  Component: dynamic(() => import('../../Schedule/Schedule').then(module => module.Schedule), {
    ssr: false
  })
}, {
  step: 'payment',
  screenViewEvent: {
    name: 'consolidated_shipping_payment'
  },
  gutter: 'narrow',
  Component: dynamic(() => import('../../ShippingPaymentConsolidated/ShippingPaymentConsolidated').then(module => module.ShippingPaymentConsolidated), {
    ssr: false
  }),
  showNavTitle: true
}, {
  step: 'finalize',
  screenViewEvent: {
    name: 'confirm_first_fix'
  },
  Component: dynamic(() => import('../../Finalize/Finalize').then(module => module.Finalize), {
    ssr: false
  }),
  hideNav: true,
  bgColor: 'mint',
  navBgColor: 'mint'
}];